export enum FilterTypeOption {
  None = 'none',
  Resolved = 'resolved',
  VisitConfirmationSuccessful = 'visit-confirmation-successful',
  OnlineBookingConversion = 'online-booking-conversion',
  Abandoned = 'abandoned',
  Archived = 'archived',
  Expired = 'expired',
}
